<footer class="footer" style="background-color: #000; color: #fff; text-align: center; margin-top:70px">
  <div class="container-fluid">
      <div class="chat-button" id="chatButton" (click)="chatBotOpen()" *ngIf="showChatButton">
          <span style="float: left;"><img src="../../../assets/images/chatbot-icon.svg" style="height: 32px;"></span>   <span class="chat-head">AI Chatbot</span>
        </div>
      <div class="row">
          <div class="col-sm-12" style="font-size: 0.875rem!important; color:#a5abb4!important">
            ©2023-24 CerebrumX Labs Inc. All rights reserved.
          </div>
      </div>
  </div>
</footer>

<ng-template #chatbotContainer let-modal>
<div role="document" class="modal-dialog newclass mt-rt modal-sx">
  <div class="modal-content newclass">
<div class="modal-header" style="height: 65px; background-color: #ef8321!important;">
<span style="float: left;">
  <img src="../../../assets/images/header-logo.png" class="icon-char"> 
</span>
<span style="float: left; margin-top:0px">
  <h5 class="name">CerebrumX Support</h5>
</span>



  <!-- Minimize Button -->
  <!-- <button type="button" class="min-btn crossbtn" (click)="minimizeChatbot();">
    <i class="bx bx-minus"></i> 
  </button> -->
  <!-- Close Button -->
  <button type="button" class="btn-close crossbtn" data-dismiss="modal" (click)="modal.dismiss('Cross click');"
    aria-hidden="true">
    <i class="bx bx-minus"></i>
  </button>
</div>
<div style="background-image: url('../../../assets/images/header.png');"></div>
<div class="modal-body" *ngIf="!isMinimized" style="height: 340px!important; overflow-y: scroll; overflow-x: hidden;"  #scrollMe [scrollTop]="scrollMe.scrollHeight">
<div class="message">
<div *ngFor="let message of messages" [ngClass]="{'user-message-container': message.isUser, 'bot-message-container': !message.isUser}">
  <img *ngIf="!message.isUser"  src="../../../assets/images/bot-image.png" class="bot-image"/>
  <p class="message-text" style="width: 80%;" *ngIf="!message.isUser" [innerHTML]="formatMessage(message.text)"></p>
  <p class="message-text-user" *ngIf="message.isUser">{{ message.text }}</p>
  <img *ngIf="message.isUser" src="../../../assets/images/user-image.png" class="user-image"  />
 
</div>

</div>
<div *ngIf="isTyping" class="typing-indicator" style="float: right;">
  <span class="typing-dot" id="dot1"></span>
  <span class="typing-dot" id="dot2"></span>
  <span class="typing-dot" id="dot3"></span>
</div>
</div>
<div class="modal-footer" *ngIf="!isMinimized" style="background-color: #f5f5f5!important;">
<div class="user-input" style="width: 84%;">
  <input type="text"  [(ngModel)]="userMessage" (keyup.enter)="sendMessage()" [ngModelOptions]="{standalone: true}" (focus)="toggleTyping()" (blur)="toggleTyping()"  placeholder="Type your message..." />
</div>
<button type="submit" class="btn-primary data-demo-history" (click)="sendMessage();"><i class="fa fa-paper-plane" style="font-size: 32px; font-weight: 600; color:#000000;"></i></button>
</div>
</div>
</div>
</ng-template>